import React, { useState } from 'react';
import api from '../api/api';
import { useNavigate, useSearchParams } from 'react-router-dom';

const ResetPasswordForm = () => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const navigate = useNavigate();

  const validatePassword = (password) => {
    const commonPasswords = ['password', '12345678', 'admin', 'qwerty'];
    if (password.length < 8) return 'La contraseña debe tener al menos 8 caracteres';
    if (!/[A-Z]/.test(password)) return 'Debe contener al menos una letra mayúscula';
    if (!/[0-9]/.test(password)) return 'Debe contener al menos un número';
    if (!/[^A-Za-z0-9]/.test(password)) return 'Debe contener al menos un carácter especial';
    if (commonPasswords.includes(password.toLowerCase())) return 'Contraseña demasiado común';
    return '';
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    const validationMsg = validatePassword(newPassword);
    if (validationMsg) {
      setError(validationMsg);
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('Las contraseñas no coinciden');
      return;
    }

    try {
      await api.post('/api/auth/reset-password', {
        token,
        new_password: newPassword,
      });
      setSuccess('Contraseña restablecida con éxito. Puedes iniciar sesión.');
      setTimeout(() => navigate('/login'), 3000);
    } catch (err) {
      console.error(err);
      setError('Error al restablecer la contraseña. El token puede haber expirado.');
    }
  };

  return (
    <div className="container mt-5">
      <div className="card p-4 shadow-sm">
        <h2 className="mb-3 text-center">Restablecer Contraseña</h2>
        {error && <div className="alert alert-danger">{error}</div>}
        {success && <div className="alert alert-success">{success}</div>}
        <form onSubmit={handleSubmit}>
          <input
            type="password"
            className="form-control mb-2"
            placeholder="Nueva contraseña"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
          <input
            type="password"
            className="form-control mb-3"
            placeholder="Confirmar contraseña"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
          <button type="submit" className="btn btn-primary w-100">
            Cambiar Contraseña
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPasswordForm;
